var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellcomSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.623,
    height: 37.365,
    viewBox: "0 0 145.623 37.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.1,47.292s-2.2-1.744-2.2-3.457c0-2.62,2.447-1.1,4.97-1.1,8.462,0,13.869-1.386,15.193-9.454.455-2.771.694-10.949-1.118-15.42-2.038-5.029-7.134-7.132-13.957-7.132-9.059,0-12.795,2.564-15.3,7.633-1.928,3.894-2.274,12.778-.424,17.618A17.565,17.565,0,0,0,26.1,47.292Z",
    transform: "translate(-12.045 -10.725)",
    fill: "#00a1ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-12.045 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(12.045 9.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M26.1,47.292s-2.2-1.744-2.2-3.457c0-2.62,2.447-1.1,4.97-1.1,8.462,0,13.869-1.386,15.193-9.454.455-2.771.694-10.949-1.118-15.42-2.038-5.029-7.134-7.132-13.957-7.132-9.059,0-12.795,2.564-15.3,7.633-1.928,3.894-2.274,12.778-.424,17.618A17.565,17.565,0,0,0,26.1,47.292Z",
    transform: "translate(-12.045 -10.725)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(5.757 -0.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M24.493,11.061a1.884,1.884,0,0,1,.622-1.555A2.7,2.7,0,0,1,26.865,9a4.452,4.452,0,0,1,1.283.175c.389.117.647.2.778.253V20.586a7.882,7.882,0,0,1,2.683-2.119,8.5,8.5,0,0,1,3.927-.875,10.1,10.1,0,0,1,3.946.758,9.433,9.433,0,0,1,3.149,2.138,9.96,9.96,0,0,1,2.1,3.266,11,11,0,0,1,.758,4.141,10.8,10.8,0,0,1-.778,4.122,9.5,9.5,0,0,1-2.177,3.266,10.172,10.172,0,0,1-3.324,2.139,11.167,11.167,0,0,1-4.218.777,12.256,12.256,0,0,1-4.219-.7,8.974,8.974,0,0,1-3.324-2.1,9.554,9.554,0,0,1-2.177-3.5,14.191,14.191,0,0,1-.777-4.937Zm10.42,23.134a5.982,5.982,0,0,0,2.43-.486,5.832,5.832,0,0,0,1.9-1.322A5.754,5.754,0,0,0,40.473,30.4,7.128,7.128,0,0,0,40.9,27.9a7.291,7.291,0,0,0-.427-2.527,5.729,5.729,0,0,0-1.225-2,5.852,5.852,0,0,0-1.9-1.322,5.982,5.982,0,0,0-2.43-.486,6.077,6.077,0,0,0-2.469.486,5.508,5.508,0,0,0-1.886,1.341,6.345,6.345,0,0,0-1.225,2.022,6.888,6.888,0,0,0-.447,2.488,7.109,7.109,0,0,0,.447,2.566,5.589,5.589,0,0,0,3.149,3.266A6.2,6.2,0,0,0,34.913,34.195Z",
    transform: "translate(-24.493 -9)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(52.104 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0.311 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M112.936,24.673c0,3.3-2.249,5.282-6.041,5.282H100.42a1.087,1.087,0,0,1-1.084-1.084v-16.8a1.087,1.087,0,0,1,1.084-1.084h5.446c3.766,0,6.041,1.978,6.041,5.282a4.447,4.447,0,0,1-1.842,3.847A4.582,4.582,0,0,1,112.936,24.673Zm-7.07-11.514H101.5V19.39h4.362c2.546,0,3.846-1.057,3.846-3.116S108.411,13.159,105.865,13.159Zm4.9,11.514c0-2.059-1.3-3.116-3.874-3.116H101.5v6.231h5.391C109.468,27.788,110.768,26.732,110.768,24.673Z",
    transform: "translate(-99.336 -10.071)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M148.518,29.782a1.087,1.087,0,0,1-1.084,1.084H137.411c.406,2.275,2.086,3.44,5.039,3.44a10.482,10.482,0,0,0,4.2-.758,1.089,1.089,0,0,1,.786,2.032,13,13,0,0,1-4.985.894c-4.552,0-7.288-2.492-7.288-6.691,0-4.172,2.492-6.665,6.692-6.665C146.026,23.117,148.518,25.609,148.518,29.782ZM137.411,28.7h8.859c-.325-2.275-1.815-3.413-4.416-3.413S137.763,26.422,137.411,28.7Z",
    transform: "translate(-118.593 -16.588)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M176.582,10.084V27.8a1.11,1.11,0,0,1-1.111,1.084,1.086,1.086,0,0,1-1.083-1.084V10.084A1.087,1.087,0,0,1,175.471,9,1.111,1.111,0,0,1,176.582,10.084Z",
    transform: "translate(-139.678 -9)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M194.132,10.084V27.8a1.111,1.111,0,0,1-1.111,1.084,1.087,1.087,0,0,1-1.084-1.084V10.084A1.087,1.087,0,0,1,193.021,9,1.111,1.111,0,0,1,194.132,10.084Z",
    transform: "translate(-149.111 -9)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M218.213,33.168a1.08,1.08,0,0,1,0,1.544,6.664,6.664,0,0,1-4.9,1.761c-4.172,0-6.692-2.492-6.692-6.691,0-4.172,2.519-6.665,6.692-6.665a6.664,6.664,0,0,1,4.9,1.761,1.08,1.08,0,0,1,0,1.544,1.1,1.1,0,0,1-1.517,0,4.61,4.61,0,0,0-3.386-1.138c-2.98,0-4.5,1.517-4.5,4.5,0,3.007,1.517,4.524,4.5,4.524a4.61,4.61,0,0,0,3.386-1.138A1.048,1.048,0,0,1,218.213,33.168Z",
    transform: "translate(-157.002 -16.588)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M253.426,29.782c0,4.2-2.492,6.691-6.692,6.691-4.172,0-6.692-2.492-6.692-6.691,0-4.172,2.52-6.665,6.692-6.665C250.934,23.117,253.426,25.609,253.426,29.782Zm-2.168,0c0-2.98-1.517-4.5-4.524-4.5-2.98,0-4.5,1.517-4.5,4.5,0,3.007,1.516,4.524,4.5,4.524C249.742,34.306,251.259,32.789,251.259,29.782Z",
    transform: "translate(-174.969 -16.588)",
    fill: "#002f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M300.257,29.782v5.608a1.1,1.1,0,0,1-2.194,0V29.782c0-2.98-1.3-4.5-3.9-4.5-2.574,0-3.9,1.517-3.9,4.5v5.608a1.084,1.084,0,1,1-2.167,0V29.782c0-2.98-1.327-4.5-3.9-4.5a3.681,3.681,0,0,0-2.9,1.084,4.987,4.987,0,0,0-1,3.414v5.608a1.1,1.1,0,0,1-2.194,0V24.2a1.1,1.1,0,0,1,2.194,0v.407a5.008,5.008,0,0,1,3.9-1.49,5.286,5.286,0,0,1,4.985,2.709,5.3,5.3,0,0,1,4.985-2.709C297.982,23.117,300.257,25.609,300.257,29.782Z",
    transform: "translate(-195.424 -16.588)",
    fill: "#002f47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M99.36,69.287c0,1.072.323,2.354,1.831,2.354a1.626,1.626,0,0,0,1.351-.575.347.347,0,0,1,.488-.052.357.357,0,0,1,.052.5,2.332,2.332,0,0,1-1.892.828c-1.6,0-2.528-1.116-2.528-3.051s.924-3.052,2.528-3.052a2.331,2.331,0,0,1,1.892.829.357.357,0,0,1-.052.5.347.347,0,0,1-.488-.052,1.626,1.626,0,0,0-1.351-.575C99.683,66.933,99.36,68.214,99.36,69.287Z",
    transform: "translate(-98.663 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M120.3,69.287c0,1.935-.924,3.051-2.528,3.051s-2.537-1.116-2.537-3.051.924-3.052,2.537-3.052S120.3,67.351,120.3,69.287Zm-.7,0c0-1.072-.314-2.354-1.831-2.354s-1.84,1.282-1.84,2.354.323,2.354,1.84,2.354S119.6,70.359,119.6,69.287Z",
    transform: "translate(-107.57 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M139.748,66.235a.35.35,0,0,1,.349.349V71.99a.349.349,0,1,1-.7,0V66.933h-.1l-1.621,5.161a.345.345,0,0,1-.332.244h-.6a.337.337,0,0,1-.331-.244l-1.631-5.161H134.7V71.99a.353.353,0,0,1-.706,0V66.584a.35.35,0,0,1,.349-.349h.706a.346.346,0,0,1,.332.244L137,71.641h.087l1.622-5.162a.356.356,0,0,1,.34-.244Z",
    transform: "translate(-117.654 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M161.419,66.235a.35.35,0,0,1,.349.349V71.99a.349.349,0,1,1-.7,0V66.933h-.1l-1.621,5.161a.345.345,0,0,1-.332.244h-.6a.337.337,0,0,1-.332-.244l-1.63-5.161h-.087V71.99a.353.353,0,0,1-.706,0V66.584a.35.35,0,0,1,.349-.349h.706a.346.346,0,0,1,.332.244l1.621,5.162h.087l1.621-5.162a.357.357,0,0,1,.34-.244Z",
    transform: "translate(-129.302 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M181.669,66.584v3.008c0,1.744-.837,2.746-2.293,2.746s-2.284-1-2.284-2.746V66.584a.349.349,0,1,1,.7,0v3.008c0,.933.279,2.049,1.587,2.049s1.6-1.116,1.6-2.049V66.584a.349.349,0,1,1,.7,0Z",
    transform: "translate(-140.82 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M199.919,66.584V71.99a.35.35,0,0,1-.349.349h-.654a.364.364,0,0,1-.314-.191l-2.607-5.214h-.079V71.99a.353.353,0,0,1-.706,0V66.584a.352.352,0,0,1,.357-.349h.645a.364.364,0,0,1,.314.192l2.607,5.214h.087V66.584a.349.349,0,1,1,.7,0Z",
    transform: "translate(-150.559 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M214.7,66.584V71.99a.344.344,0,0,1-.349.349A.35.35,0,0,1,214,71.99V66.584a.35.35,0,0,1,.349-.349A.345.345,0,0,1,214.7,66.584Z",
    transform: "translate(-160.659 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M224.126,69.287c0,1.072.323,2.354,1.831,2.354a1.626,1.626,0,0,0,1.351-.575.347.347,0,0,1,.488-.052.357.357,0,0,1,.052.5,2.33,2.33,0,0,1-1.892.828c-1.6,0-2.528-1.116-2.528-3.051s.924-3.052,2.528-3.052a2.329,2.329,0,0,1,1.892.829.357.357,0,0,1-.052.5.347.347,0,0,1-.488-.052,1.626,1.626,0,0,0-1.351-.575C224.449,66.933,224.126,68.214,224.126,69.287Z",
    transform: "translate(-165.727 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M245.192,71.876a.355.355,0,0,1-.227.445.351.351,0,0,1-.445-.218l-.514-1.569h-2.729l-.488,1.56a.346.346,0,0,1-.436.227.351.351,0,0,1-.235-.436l1.7-5.406a.355.355,0,0,1,.339-.244h.9a.349.349,0,0,1,.332.235Zm-1.421-2.04-.968-2.9h-.392l-.916,2.9Z",
    transform: "translate(-174.69 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M259.981,66.584a.35.35,0,0,1-.349.349H258.28V71.99a.353.353,0,0,1-.706,0V66.933h-1.351a.349.349,0,0,1,0-.7h3.409A.35.35,0,0,1,259.981,66.584Z",
    transform: "translate(-183.167 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M272.809,66.584V71.99a.344.344,0,0,1-.349.349.35.35,0,0,1-.349-.349V66.584a.35.35,0,0,1,.349-.349A.344.344,0,0,1,272.809,66.584Z",
    transform: "translate(-191.896 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M286.607,69.287c0,1.935-.925,3.051-2.529,3.051s-2.537-1.116-2.537-3.051.924-3.052,2.537-3.052S286.607,67.351,286.607,69.287Zm-.7,0c0-1.072-.314-2.354-1.831-2.354s-1.839,1.282-1.839,2.354.322,2.354,1.839,2.354S285.909,70.359,285.909,69.287Z",
    transform: "translate(-196.964 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M305.008,66.584V71.99a.349.349,0,0,1-.348.349h-.654a.364.364,0,0,1-.314-.191l-2.607-5.214h-.079V71.99a.353.353,0,0,1-.706,0V66.584a.352.352,0,0,1,.358-.349h.646a.363.363,0,0,1,.314.192l2.607,5.214h.088V66.584a.348.348,0,1,1,.7,0Z",
    transform: "translate(-207.047 -39.765)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M322.216,70.682c0,1.072-.733,1.657-2.023,1.657a3.1,3.1,0,0,1-1.9-.549.35.35,0,0,1,.444-.541,2.339,2.339,0,0,0,1.465.392c.906,0,1.317-.323,1.317-.976,0-.471-.157-.95-1.387-1.029A1.711,1.711,0,0,1,318.3,67.9c0-1.029.715-1.665,1.91-1.665h.026a2.653,2.653,0,0,1,1.587.445.349.349,0,1,1-.419.558,1.892,1.892,0,0,0-1.168-.305c-.828,0-1.238.322-1.238.959,0,.8.61,1.011,1.168,1.047C321.536,69.025,322.216,69.61,322.216,70.682Z",
    transform: "translate(-216.652 -39.765)",
    fill: "#00a1ed"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellcomSmall);
export default __webpack_public_path__ + "static/media/bellcom-small.bb180358a221605bd772d0880db94bdb.svg";
export { ForwardRef as ReactComponent };